export const styles = {
  orgTree: {
    overflow: 'auto',
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
};
